<!--
  キャラサムネイル
-->


<template>
    <li class="chara-thumb">
        <router-link :to="{name:'chara', params:{story:story, id:id}}" class="chara-thumb__link">
            <img :src="thumb" alt="">
        </router-link>
    </li>
</template>


<script>
// キャラ用データ
// import chara_data from '../../js/page/chara_data';


export default {
    props: {
        story: String,
        id: String,
        thumb: String
    }
};
</script>



// WEBPACK FOOTER //
// chara-thumb.vue?17206feb